{
  "name": "jatt",
  "private": true,
  "version": "1.28.0",
  "type": "module",
  "scripts": {
    "dev": "vite --host",
    "build": "tsc -b && vite build",
    "lint": "eslint .",
    "preview": "vite preview",
    "test": "npm run test:coverage && npm run test:e2e && npm run coverage:merge",
    "test:unit": "vitest --coverage",
    "test:coverage": "vitest run --coverage",
    "test:e2e": "playwright test",
    "test:e2e:ui": "playwright test --ui",
    "coverage:merge": "node scripts/merge-coverage.js"
  },
  "dependencies": {
    "@supabase/supabase-js": "^2.105.0",
    "@tailwindcss/vite": "^4.2.4",
    "date-fns": "^4.1.0",
    "exceljs": "^4.4.0",
    "lucide-react": "^1.11.0",
    "react": "^19.2.5",
    "react-dom": "^19.2.5",
    "tailwindcss": "^4.2.4",
    "xlsx": "^0.18.5"
  },
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "@playwright/test": "^1.61.1",
    "@semantic-release/changelog": "^6.0.3",
    "@semantic-release/git": "^10.0.1",
    "@semantic-release/github": "^12.0.9",
    "@semantic-release/npm": "^13.1.5",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/jest-dom": "^7.0.1",
    "@testing-library/react": "^16.3.3",
    "@testing-library/user-event": "^14.6.6",
    "@types/node": "^24.12.2",
    "@types/react": "^19.2.14",
    "@types/react-dom": "^19.2.3",
    "@vitejs/plugin-react": "^6.0.1",
    "@vitest/coverage-v8": "^4.1.11",
    "eslint": "^10.2.1",
    "eslint-plugin-react-hooks": "^7.1.1",
    "eslint-plugin-react-refresh": "^0.5.2",
    "eslint-plugin-sonarjs": "^4.2.1",
    "globals": "^17.5.0",
    "jsdom": "^29.1.1",
    "lcov-result-merger": "^6.0.0",
    "monocart-coverage-reports": "^2.13.0",
    "pg": "^8.22.0",
    "semantic-release": "^25.0.5",
    "typescript": "~6.0.2",
    "typescript-eslint": "^8.58.2",
    "vite": "^8.0.10",
    "vitest": "^4.1.5"
  }
}
